import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { Store } from './store';

// Extract the RootState and AppDispatch types from your store
type RootState = ReturnType<typeof Store.getState>;
type AppDispatch = typeof Store.dispatch;

// Create typed hooks
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;